import script from "./WhatsappBlocker.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappBlocker.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styleWhatsappBlocker.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__